import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Icon from '@cotyorg/ccx-atoms/Icon';

const findShadeBySku = selectedSku => R.find((R.propEq('sku', selectedSku)));

const getOnChange = ({
  setProductSKU,
  onChange,
  swatches,
}) => (event) => {
  const sku = event.target.value;
  setProductSKU(sku);
  if (onChange) {
    onChange({
      shade: R.prop('itemName', findShadeBySku(event.target.value)(swatches)),
      sku,
    });
  }
};

const ProductSwatchDropdown = ({
  selectedSKU,
  swatches,
  setProductSKU,
  chevronIconSrc,
  onChange,
  testAttribute = 'product-swatch-dropdown',
  label
}) => (
  R.length(swatches) > 1 ? (
    <div className="product-dropdown">
      <select
        data-test={testAttribute}
        className="product-select"
        value={selectedSKU}
        name="product-swatch-dropdown"
        title={label}
        aria-label={label}
        onChange={getOnChange({
            setProductSKU,
            onChange,
            swatches,
          })
        }
      >
        { swatches.map(({ sku, itemName }) => (
          <option key={sku} value={sku}>{itemName}</option>
        ))}
      </select>
      <Icon iconExtraClass="product-dropdown__chevron" iconSrc={chevronIconSrc} />
    </div>
  ) : null);

ProductSwatchDropdown.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    sku: PropTypes.string.isRequired,
    skuColor: PropTypes.string.isRequired,
    itemName: PropTypes.string.isRequired,
  })),
  selectedSKU: PropTypes.string,
  setProductSKU: PropTypes.func.isRequired,
  chevronIconSrc: PropTypes.string,
  onChange: PropTypes.func,
  testAttribute: PropTypes.string,
  label: PropTypes.string,
};

export default ProductSwatchDropdown;
